import {
  MapDataTip,
  DomEventListener,
  MapUtil,
  DataQuery,
  DataValueFormatter,
  DomUtil,
  Localization,
  SymbolPointSymbolizer
} from "cartovista";
import {drawStyleIconCanvas} from "../utils/CvUtils";

var timer;

class MapDataTipExtend extends MapDataTip {
  show(e, t, i, r, dataTipExtend) {
      if (e) {
          if (dataTipExtend) {
              super.show(e, t, i, false);
              this.updatePosition(t, i, false);
          } else if (this._mapDataTipFilter(e)) {
              clearTimeout(timer);
              super.show(e, t, i, r);
          }
      }
}

_mapDataTipFilter(content) {
    //mapDataTip created by BtnCircularSelectionTool --> passed
    if (content.indexOf(Localization.getValue("global.radius") + Localization.getValue("global.colon")) >= 0) return true;
    //mapDataTip created by BtnRectangularSelectionTool --> passed
    else if (content.indexOf(Localization.getValue("global.width") + Localization.getValue("global.colon")) >= 0) return true;
    //mapDataTip created by BtnRulerTool --> passed
    else if (content.indexOf("Distance" + Localization.getValue("global.colon")) >= 0) return true;
    //mapDataTip created by BtnAreaMeasuringTool --> passed
    else if (content.indexOf(Localization.getValue("global.perimeter") + Localization.getValue("global.colon")) >= 0) return true;
    //mapDataTip created by default rollover --> rejected in favor of our DataTipExtend
    else return false;
};
}

    export default class DataTipExtend {
      constructor(delay, naValue) {
        //ms without moving before displaying the mapDataTip
        this._delay = delay;
        //value to display in the dataTip when data is null (if undefined, default naValue is used)
        this._naValue = naValue;
        this._map = window.cartovista.externalInterface.map;
        this._mapController = window.cartovista.getMapController(this._map);
        this._divMap = this._mapController.divMap;
        DomEventListener.addListener(this._divMap, "mousemove", this._onMapMouseMove.bind(this));
        //DomEventListener.addListener(this._divMap, "touchend", this._onMapMouseMove.bind(this));
        DomEventListener.addListener(this._divMap, "mouseleave", function() { clearTimeout(timer); });
      }

    //mapDataTip will be displayed atfer the timer if featuresAtPoint is not empty
    _onMapMouseMove(e) {
        clearTimeout(timer);
        this._mapController._mapDataTip.hide(true);
        timer = setTimeout(function() {
            var featuresCollection = this._getFeaturesCollectionAtPoint(e);
            if (featuresCollection.length) {
                this._createDataTipHTML(featuresCollection)
                    .then(function(dataTipHTML) {
                        this._mapController._mapDataTip.show(dataTipHTML, e.clientX + 20, e.clientY - 50, undefined, true);
                    }.bind(this));
            }
        }.bind(this), this._delay);
    };

    //get features list at mouse position
    _getFeaturesCollectionAtPoint(e) {
        var MouseCoordinates = DomUtil.getCursorPosition(e, this._mapController),
            x = Math.round(MapUtil.screenXtoMapX(MouseCoordinates.x, this._mapController._map.width, this._mapController._map.extent)),
            y = Math.round(MapUtil.screenYtoMapY(MouseCoordinates.y, this._mapController._map.height, this._mapController._map.extent));
        //loop in reverse order to display features dataTip correctly (point layer on top)
        return _.reduceRight(this._map.layers, function(featuresCollection, layer) {
            //don't use layer.dataTipEnabled to filter because always true when layer is published from cvm even when should be false
            if (layer.layerType != "TILE" && layer.layerType != "WMS" && layer.isVisible && (layer.dataTipDataColumns.length || (layer.dataTipDataColumnsDisplayMode != "NONE" && layer.activeOverlayTheme || layer.activeStyleTheme))) {
                var radius = MapUtil.getSearchAtPointRadius(layer, this._map);
                layer.getFeaturesByPoint(x, y, radius, null, function(found) {
                    if (found.features.length) {
                        featuresCollection.push({"layer": layer, "feature": layer.layerType == "POINT" ? found.features[0] : found.features[found.features.length-1]});
                    }
                });
            }
            return featuresCollection;
        }.bind(this), []);
    };

    //assemble each feature's mapDataTip html into one popup container
    _createDataTipHTML(featuresCollection) {
        return Promise.all(_.map(featuresCollection, this._createFeatureHTML.bind(this)))
            .then(function(featuresHTML) {
                return '<table id="dataTipExtend" class="table table-condensed table-bordered" style="margin:6px 0px 0px; border-collapse:collapse;">' + featuresHTML.join("") + '</table>';
            });
    };

    _createFeatureHTML(featureCollection) {
        var headerHTML = '<tr>' +
                            '<th colspan="2" style="padding-top:2px; padding-bottom:2px; color:black; background-color:rgba(255,255,255,0.8); border-color:#bbb;">' +
                                (!featureCollection.layer.isClusteringActivated ? '<span style="margin-right:4px;">' + this._getIconImg(featureCollection.feature) + '</span>' :
                                    featureCollection.feature.featureCount == 1 ? '<span style="margin-right:4px;">' + this._getIconImg(featureCollection.feature.centerFeature) + '</span>' :
                                "") +
                                '<span style="vertical-align:middle;">' + featureCollection.layer.name + '</span>' +
                            '</th>' +
                        '</tr>';
        if (featureCollection.layer.isClusteringActivated) {
            if (featureCollection.feature.featureCount > 1) {
                //grouped features in cluster
                return headerHTML + this._createClusterContentHTML(featureCollection.layer, featureCollection.feature);
            } else {
                //feature is not grouped in a cluster --> display mapDataTip as simpleHTML
                return this._createSimpleContentHTML(featureCollection.layer, featureCollection.feature.centerFeature).then(function(contentHTML) {
                    return headerHTML + contentHTML;
                });
            }
        } else {
            return this._createSimpleContentHTML(featureCollection.layer, featureCollection.feature).then(function(contentHTML) {
                return headerHTML + contentHTML;
            });
        }
    };

    _getIconImg(feature) {
        var style = _.cloneDeep(feature.getStyleThemeOverride() ? this._getFeatureThemeStyle(feature) : feature.style),
            canvas = document.createElement("canvas");
        switch (style.symbolizers[0].toString()) {
            case "SymbolPointSymbolizer":
                style.symbolizers[0].size = style.symbolizers[0].size > 18 ? 18 : style.symbolizers[0].size;
                canvas.height = style.symbolizers[0].size <= 18 ? style.symbolizers[0].size : 18;
                canvas.width = style.symbolizers[0].size <= 18 ? style.symbolizers[0].size : 18;
                return '<img alt="icon" height="' + canvas.height + '" width="' + canvas.width + '" src="' + drawStyleIconCanvas(canvas, style).toDataURL() + '"/>';
            case "ImagePointSymbolizer":
                return '<img alt="icon" height="18" width="18" src="' + drawStyleIconCanvas(canvas, style).toDataURL() + '"/>';
            case "AnnotationSymbolizer":
                return '<span style="border:1px solid #bbb; padding:1px;"><span class="glyphicon glyphicon-font"></span><span style="font-size:8px;" class="glyphicon glyphicon-font"></span></span>';
            case "PolylineSymbolizer":
                canvas.height = style.symbolizers[0].strokeWidth;
                canvas.width = 14;
                return '<img alt="icon" height="' + canvas.height + '" width="14" src="' + drawStyleIconCanvas(canvas, style).toDataURL() + '"/>';
            case "PolygonSymbolizer":
                canvas.height = 14;
                canvas.width = 14;
                return '<img alt="icon" height="14" width="14" src="' + drawStyleIconCanvas(canvas, style).toDataURL() + '"/>';
            default:
                throw new Error("DataTipExtend._getIconImg() - symbolizer type: " + style.symbolizers[0].toString() + " is invalid.");
        };
    };

    _getFeatureThemeStyle(feature) {
        var thematicStyle = feature.getStyleThemeOverride();
        var style = _.cloneDeep(feature.style);
        switch (style.symbolizers[0].toString()) {
            case "SymbolPointSymbolizer":
                if(thematicStyle.symbol){
                    style.symbolizers[0].symbolChar = thematicStyle.symbol;
                    style.symbolizers[0].fontName = "CartoVistaSymbols";
                } else{
                    style.symbolizers[0].symbolChar = style.symbolizers[0].symbolChar
                }
                style.symbolizers[0].color = thematicStyle.color ? thematicStyle.color : style.symbolizers[0].color;
                style.symbolizers[0].size = thematicStyle.size ? thematicStyle.size : style.symbolizers[0].size;
                break;
            case "ImagePointSymbolizer":
                //not implemented yet
                break;
            case "PolylineSymbolizer":
                style.symbolizers[0].strokeColor = thematicStyle.color ? thematicStyle.color : style.symbolizers[0].strokeColor;
                style.symbolizers[0].strokeWidth = thematicStyle.size ? thematicStyle.size : style.symbolizers[0].strokeWidth;
                break;
            case "PolygonSymbolizer":
                if (thematicStyle.color) {
                    style.symbolizers[0].fillColor1 = thematicStyle.color;
                    style.symbolizers[0].fillStyle = "SOLID";
                } else if (thematicStyle.patternColor) {
                    style.symbolizers[0].fillColor1 = thematicStyle.patternColor;
                    style.symbolizers[0].fillStyle = "PATTERN";
                }
                break;
            default:
                throw new Error("DataTipExtend._getFeatureThemeStyle() - symbolizer type: " + style.symbolizers[0].toString() + " is invalid.");
        };
        return style;
    };

    //create mapDataTip html for features with cluster
    _createClusterContentHTML(layer, clusterFeature) {
        var groups = _.groupBy(_.concat([clusterFeature.centerFeature], clusterFeature.features), "style.id");
        return '<tr>' +
                    '<td colspan="2" style="padding:2px 4px; border-color:#bbb; color:white;">' +
                        '<strong>Nombre d\'entités:&nbsp;' + clusterFeature.featureCount + '</strong><br>' +
                        _.map(groups, function(group) {
                            return '<span style="margin-right:5px;">' + this._getIconImg(group[0]) + '&nbsp;' + group.length + '</span>';
                        }.bind(this)).join("") +
                    '</td>' +
                '</tr>';
    };

    //create mapDatatip html for features without cluster
    _createSimpleContentHTML(layer, feature) {
        return new Promise(function(resolve, reject) {
            var columns = _.concat([], layer.dataTipDataColumns);
            layer.getDataColumns(layer.dataTipDataColumnsDisplayMode, function(result)
            {
                columns = _.concat(columns, result);
            });
            if(columns.length){
              new DataQuery(columns, [feature.id])
                  .execute(function(result) {
                      resolve(_.map(columns, function(column, idx) {
                          var formatedValue = this._getFormatedColumnValue(column, result.values[column.dataTable.id][column.id][0]);
                          return '<tr>' +
                                      '<th style="padding:2px 4px; vertical-align:middle; border-color:#bbb;color:white;">' + column.name + '</th>' +
                                      '<td style="padding:2px 4px; vertical-align:middle; border-color:#bbb;color:white;">' +  formatedValue + '</td>' +
                                  '</tr>';
                      }.bind(this)).join(""));
                  }, this);
            }            
        }.bind(this));
    };

    _getFormatedColumnValue(column, value) {
        if (value != null) {
            switch (column.dataType) {
                case "NUMBER":
                case "STRING":
                case "DATE_TIME":
                case "UNKNOWN":
                    return DataValueFormatter.formatValue(value, column, null, null, true);
                case "IMAGE_URL":
                    return '<img src="' + value + '" />';
                default:
                    throw new Error("DataTipExtend._getFormatedColumnValue() - column.dataType: " + column.dataType + " is invalid.");
            };
        } else {
            return typeof this._naValue != "undefined" ? this._naValue : Localization.getValue("global.notAvailable");
        }
    };

}
